import { combineReducers, configureStore } from '@reduxjs/toolkit';
import themeSettingSlice from './themeSettingSlice';
import sidebarSlice from './sidebarSlice';
import authSlice  from './authSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
    key: "auth",
    storage,
    whitelist: ["token", "userId", "isAuthenticated", "backupStack"],
};

const rootReducer = combineReducers({
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    auth: persistReducer(persistConfig, authSlice),
});

const store = configureStore({
    reducer: rootReducer,
});

export default store;
export const persistor = persistStore(store);